import { useMemo } from "react";
import { tasksId } from "../types/activityTasks";

export const useGetInsings = (activitiesInformation = {}) => {
	const getBadgets = useMemo(() => {
		//* variables
		let allData = {
			badgets: [],
			numberCompleteBadgets: 0,
		};
		//* separar mi json en mis topics
		const valuesTopics = Object.values(tasksId);
		//* checar las task de los topic
		valuesTopics.forEach((topic) => {
			//* sacamos los topic de los temas
			const valuesSubTopic = Object.values(topic.activities);
			valuesSubTopic.forEach((name) => {
				//* verificamos que el nombre llegue a el json de redux
				const getActivityState = activitiesInformation[name];
				if (getActivityState !== undefined) {
					const { task } = getActivityState;
					task.forEach((t) => {
						const complete = t?.isComplete ?? false;
						if (complete) {
							allData.numberCompleteBadgets++;
						}
						allData.badgets.push({ color: "", complete });
					});
				}
			});
			//*
		});
		return allData;
	}, [activitiesInformation]);

	return {
		badgets: getBadgets.badgets,
		numberCompleteBadgets: getBadgets.numberCompleteBadgets,
	};
};
